import { useMutation } from "@tanstack/react-query";
import { useNavigate } from "@tanstack/react-router";
import { App } from "antd";
import { useTranslation } from "react-i18next";
import { authService } from "../services/auth.service";
import { useAuthStore } from "../store/auth.store";
import type { LoginRequest } from "../types";

export function useLogin() {
	const { message } = App.useApp();
	const { t } = useTranslation("auth");
	const navigate = useNavigate();
	const setAuth = useAuthStore((state) => state.setAuth);

	return useMutation({
		mutationFn: (data: LoginRequest) => authService.login(data),
		onSuccess: (response) => {
			setAuth(response.user, response.accessToken);
			message.success(t("messages.loginSuccess"));
			navigate({ to: "/dashboard" });
		},
		onError: () => {
			message.error(t("messages.loginError"));
		},
	});
}

export function useLogout() {
	const { message } = App.useApp();
	const { t } = useTranslation("auth");
	const navigate = useNavigate();
	const logout = useAuthStore((state) => state.logout);

	return useMutation({
		mutationFn: () => authService.logout(),
		onSettled: () => {
			// Server javobidan qat'i nazar lokal holatni tozalaymiz.
			// ⚠️ «Yaqinda ko'rilgan» ro'yxati bu yerda ALOHIDA tozalanmaydi —
			// uni `useAuthStore.logout()` ning o'zi qiladi, chunki chiqishning
			// ikkinchi yo'li (`app/api/client.ts` da sessiya muddati tugaganda)
			// bu hook'ni umuman chetlab o'tadi.
			logout();
			message.success(t("messages.logoutSuccess"));
			navigate({ to: "/login" });
		},
	});
}
